import React from 'react';

import { SplitBlockAppearance, SplitBlockVideo } from 'api/cms';
import { Box } from 'components/Box';
import { Button } from 'components/Button';
import Video, { PlayButton } from 'components/Video';
import ShowModalContainer from 'containers/ShowModalContainer';
import { colors, gutterWidth } from 'theme';

type Props = {
  appearance: SplitBlockAppearance;
  blockId: string;
  index: number;
  preview: boolean;
  section: SplitBlockVideo;
};

export function VideoContent({
  appearance,
  blockId,
  index,
  preview,
  section,
}: Props) {
  const overlapping = appearance === 'OVERLAPPING';
  const fullWidth = appearance === 'FULL_WIDTH';

  return (
    <Box
      data-qa-id={`split-content-section-${index}`}
      position={[undefined, null, !fullWidth ? 'relative' : undefined]}
      width={[1, null, 1 / 2]}
      px={[gutterWidth / 4, null, gutterWidth / 2]}
      py={[gutterWidth / 4, null, gutterWidth / 2]}
      key={blockId}
    >
      <Box
        position={[null, null, fullWidth && !preview ? 'absolute' : undefined]}
        left={[null, null, '50%']}
        top={[null, null, '50%']}
        transform={[
          null,
          null,
          fullWidth && !preview && 'translate(-50%, -50%)',
        ]}
        height={[
          '100%',
          null,
          overlapping || fullWidth
            ? `calc(100% + ${overlapping ? gutterWidth * 2 : gutterWidth}px)`
            : '100%',
        ]}
        mt={overlapping && [0, null, -gutterWidth]}
        width={
          overlapping
            ? [
                1,
                null,
                fullWidth ? '100vw' : `calc(100% + ${gutterWidth * 3}px)`,
              ]
            : 1
        }
        ml={[0, null, overlapping && index === 1 && -gutterWidth * 3]}
        overflow="hidden"
        borderRadius="24px"
        bg={colors.fog}
      >
        <ShowModalContainer
          render={(showModal) => (
            <Box
              component={Button}
              position="relative"
              width="100%"
              height="100%"
              onClick={() => {
                showModal('MEDIA_GALLERY', {
                  items: [
                    {
                      type: 'VIDEO',
                      videoUrl: section.data.url,
                    },
                  ],
                  itemIndex: 0,
                });
              }}
              aria-label={getText('Open video')}
            >
              <Video
                minHeight={['50vw', null, '25vw', (540 * 9) / 16]}
                url={section.data.url}
                prefix="split-block-video-"
                fill
                noPlayer
                hideButton={fullWidth}
              />
            </Box>
          )}
        />
        {fullWidth ? (
          <Box
            position="absolute"
            top="50%"
            left={['50%', null, index === 0 ? '25%' : '75%']}
            transform="translate(-50%, -50%)"
            pointerEvents="none"
          >
            <PlayButton />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
